interface LogoProps {
  readonly size?: "sm" | "md" | "lg";
  readonly showWordmark?: boolean;
}

const SIZE_MAP = {
  sm: { img: 28, title: "text-base" },
  md: { img: 36, title: "text-lg" },
  lg: { img: 56, title: "text-2xl" },
} as const;

export function Logo({ size = "md", showWordmark = true }: LogoProps) {
  const s = SIZE_MAP[size];
  return (
    <div className="flex items-center gap-3">
      <img
        src="/logo.webp"
        alt="CrowUsage"
        width={s.img}
        height={s.img}
        className="object-contain"
      />
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span className={`font-bold text-content-primary ${s.title}`}>
            Crow<span className="text-accent">Usage</span>
          </span>
          <span className="text-[11px] font-medium tracking-[0.14em] text-content-tertiary uppercase">
            API insights
          </span>
        </div>
      )}
    </div>
  );
}
